import cx from 'classnames'
import PropTypes from 'prop-types'
import { Component } from 'react'

import { Paper } from '../Paper'
import './styles.scss'

export class Card extends Component {
  render () {
    const {
      accentTitle,
      children,
      title,
      titleRight,
      barColor,
      noBar,
      height,
      width,
      style,
      noBorderRadius,
      noTopBorderRadius,
      ...other
    } = this.props

    const cardClass = cx({
      'nh-card': true,
      'accent-title': accentTitle,
      'transparent-bar': noBar === true,
      'grey-bar': barColor === 'grey',
      'blue-bar': barColor === 'blue',
      'green-bar': barColor === 'green',
      'orange-bar': barColor === 'orange',
      'yellow-bar': barColor === 'yellow',
      'red-bar': barColor === 'red',
      'purple-bar': barColor === 'purple'
    })

    const heightPropToString = h => {
      if (h === 'auto' || /(%|px|vh|vw)$/.test(h)) {
        return h
      }
      return `${h}px`
    }

    return (
      <Paper
        {...other}
        zDepth={0}
        noPadding
        noTopBorderRadius={noTopBorderRadius}
        style={{
          width,
          height: heightPropToString(height),
          ...style
        }}
      >
        <div className={cardClass}>
          {title && titleRight && (
            <h2 className='card-title justify'>
              {title}
              {titleRight}
            </h2>
          )}
          {title && !titleRight && <h2 className='card-title'>{title}</h2>}
          {children}
        </div>
      </Paper>
    )
  }
}

Card.defaultProps = {
  barColor: 'grey',
  height: 230
}

Card.propTypes = {
  children: PropTypes.node,
  accentTitle: PropTypes.bool,
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
  titleRight: PropTypes.oneOfType([ PropTypes.string, PropTypes.element ]),
  width: PropTypes.number,
  height: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  style: PropTypes.instanceOf(Object),
  barColor: PropTypes.oneOf([
    'grey',
    'blue',
    'green',
    'red',
    'orange',
    'yellow',
    'purple'
  ]),
  noBar: PropTypes.bool,
  noMargin: PropTypes.bool
}
